(function(){
  const q=s=>document.querySelector(s), qa=s=>Array.from(document.querySelectorAll(s));
  const parse=id=>{try{return JSON.parse(q(id)?.textContent||'[]')}catch(e){return[]}};
  const individual=parse('#BagorithmIndividualVariants');
  const couple=parse('#BagorithmCoupleVariants');
  const doublePack=parse('#BagorithmDoubleVariants');
  const shop=q('#BagorithmShopData');
  if(!shop||!individual.length)return;
  const currency=shop.dataset.currency||'EUR';
  const locale=shop.dataset.locale||'es-ES';
  const soloKeyword=(shop.dataset.soloKeyword||'Sin bomba').toLowerCase();
  const completeKeyword=(shop.dataset.completeKeyword||'Con bomba').toLowerCase();
  const norm=v=>(v||'').toString().trim().toLowerCase();
  const money=cents=>{try{const zeroDecimal=currency==='COP';const digits=zeroDecimal?0:2;const s=new Intl.NumberFormat(locale,{style:'currency',currency,minimumFractionDigits:digits,maximumFractionDigits:digits}).format((Number(cents)||0)/100);return (currency==='MXN'||currency==='COP')?s+' '+currency:s}catch(e){return ((Number(cents)||0)/100).toFixed(2)+' '+currency}};
  const pct=v=>v&&v.compareAt>v.price?Math.round(((v.compareAt-v.price)/v.compareAt)*100):0;
  const byVersion=version=>individual.find(v=>v.available!==false&&v.options.some(o=>norm(o).includes(version==='solo'?soloKeyword:completeKeyword)))||individual.find(v=>v.options.some(o=>norm(o).includes(version==='solo'?soloKeyword:completeKeyword)))||individual[0];
  function ensureTabBadge(tab,id){if(!tab)return null;let b=q('#'+id);if(!b){b=document.createElement('span');b.id=id;b.className='tab-saving-badge';tab.appendChild(b)}return b}
  function ensureTabCompare(tab,id){if(!tab)return null;let s=q('#'+id);if(!s){s=document.createElement('s');s.id=id;s.className='tab-compare-price';const small=tab.querySelector('small');if(small)tab.insertBefore(s,small);else tab.appendChild(s)}return s}
  function ensureSingleCompare(){const price=q('#singleCardPrice');if(!price)return null;let s=q('#singleBefore');if(!s){s=document.createElement('s');s.id='singleBefore';price.insertAdjacentElement('afterend',s)}return s}
  function selectedVersion(){return q('.version-tab.active')?.dataset.version||'complete'}
  function setSaving(el,v,prefix){if(!el||!v)return;const p=pct(v);const diff=Math.max(0,(v.compareAt||0)-(v.price||0));el.textContent=p>0?(prefix||'AHORRAS')+' '+p+'% · '+money(diff):(prefix||'MEJOR PRECIO')}
  function updateSavings(){
    const solo=byVersion('solo'), complete=byVersion('complete');

    const current=selectedVersion()==='solo'?solo:complete;
    const singleBefore=ensureSingleCompare();
    if(singleBefore)singleBefore.textContent=current&&current.compareAt>current.price?money(current.compareAt):'';
    const singleCard=q('[data-pack="single"]');
    if(singleCard){let save=singleCard.querySelector('.saving');if(save){save.id='singleSaving';setSaving(save,current,'AHORRAS')}}
    const cv=couple[0], dv=doublePack[0];
    if(cv){const before=q('#coupleBefore');if(before)before.textContent=cv.compareAt>cv.price?money(cv.compareAt):'';setSaving(q('#coupleSaving'),cv,'AHORRAS');const badge=q('.pack.best .badge');if(badge)badge.textContent='★ MEJOR OFERTA · AHORRA '+pct(cv)+'%'}
    if(dv){const before=q('#doubleBefore');if(before)before.textContent=dv.compareAt>dv.price?money(dv.compareAt):'';setSaving(q('#doubleSaving'),dv,'AHORRAS')}
  }
  function updateFinalCta(){
    const anchor=q('.final-cta-link');
    if(!anchor)return;
    const solo=byVersion('solo');
    const cv=couple.find(v=>v.available!==false)||couple[0];
    if(!solo||!cv)return;
    anchor.classList.add('bagorithm-final-cta-link');
    anchor.innerHTML='<div class="bagorithm-final-cta-card">'
      +'<h3>Tu próximo viaje puede empezar con <span>una mochila menos que facturar.</span></h3>'
      +'<p>Elige la Bagorithm que mejor encaje contigo y sigue usándola viaje tras viaje.</p>'
      +'<ul>'
      +'<li>✓ Una mochila desde <strong>'+money(solo.price)+'</strong> (bomba eléctrica opcional)</li>'
      +'<li>✓ Pack Pareja Inteligente: 2 mochilas + 1 bomba por <strong>'+money(cv.price)+'</strong></li>'
      +'<li>✓ Envío gratis con seguimiento</li>'
      +'</ul>'
      +'<span class="bagorithm-final-cta-button">ELIGE TU BAGORITHM</span>'
      +'</div>';
  }
  function afterExistingUpdate(){setTimeout(updateSavings,0)}
  qa('.version-tab,.pack,.swatch').forEach(el=>el.addEventListener('click',afterExistingUpdate));
  ['#pairColor1','#pairColor2'].forEach(sel=>q(sel)?.addEventListener('change',afterExistingUpdate));
  updateSavings();
  updateFinalCta();
})();
